module.exports = __webpack_public_path__ + "img/product-plsc-one.4145d7f.png";